/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-23.
 * Populates checkbox from database or event if you want to use it
 * with hardcoded data, you can define data on TYPES
 *
 * Returns the selected values as an array.
 */
import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { Checkbox } from 'material-ui';
import { statuses } from '../../services';
import { extractProperty } from '../../common/helpers';

const services = { statuses };

const TYPES = {
    STATUSES: {
        key: 'statuses',
        service: 'statuses',
        url: 'clearenceStatuses',
        entity: 'clearenceStatuses',
        params: {}
    },
    VIAS: {
        key: 'vias',
        service: '',
        url: '',
        entity: '',
        params: {},
        data: [
            { id: 'MARITIMA', name: 'Maritima' },
            { id: 'TERRESTRE', name: 'Terrestre' },
            { id: 'AEREA', name: 'Aerea' }
        ]
    },
    IMPORT_EXPORT: {
        key: 'types',
        service: '',
        url: '',
        entity: '',
        params: {},
        data: [
          { id: 'IMPORT', name: 'IMPORTACIÓN' },
          { id: 'EXPORT', name: 'EXPORTACIÓN' }
        ]
    },
    APPLICABLES:{
        key: 'applicables',
        service:'',
        url:'',
        entity:'',
        params:{},
        data: [
          { id: 'PEDIMENTO', name: 'Por Pedimento' },
          { id: 'CONTENEDOR', name: 'Por Contenedor' },
          { id: 'OPERACION', name: ' Por Operacion' }
        ]
    }
};

class RemoteCheckboxGroup extends Component {
    static TYPES = TYPES;

    constructor() {
        super();
        this.state = {
            remoteDataSource: []
        };
    }

    /**
     * Loads the data to populate remotelly the checkboxes
     */
    componentWillMount() {
        const { dataType: { service, url, params, entity, data = [] } } = this.props;

        if (data.length > 0) {
            return this.setState({ remoteDataSource: data });
        }

        return services[service].get(url, params).then(result => {
            return this.setState({
                remoteDataSource: result._embedded[entity]
            });
        });
    }

    render() {
        const { remoteDataSource } = this.state;
        const { displayProp, valueProp, notify, selectedValues = [] } = this.props;

        return (
            <div>
                {
                    remoteDataSource.map((item, index) => {
                        return (
                            <Checkbox
                                key={index}
                                label={displayProp(item)}
                                labelPosition="right"
                                checked={selectedValues.indexOf(item[valueProp]) > -1}
                                onCheck={(event, value) => {
                                    if (value) {
                                        const values = [...selectedValues, remoteDataSource[index][valueProp]];//extractProperty(newData.filter(itm => itm.checked), valueProp);
                                        notify(values);
                                    } else {
                                        var i = selectedValues.indexOf(item[valueProp]);
                                        if(i != -1) {
                                        	selectedValues.splice(i, 1);
                                        }
                                        const values=selectedValues;
                                        notify(values);
                                    }
                                }}
                            />
                        );
                    })
                }
            </div>
        );
    }
}

RemoteCheckboxGroup.propTypes = {
    dataType: Proptypes.shape({
        key: Proptypes.string.isRequired,
        service: Proptypes.string.isRequired,
        url: Proptypes.string.isRequired,
        entity: Proptypes.string.isRequired,
        params: Proptypes.object.isRequired
    }).isRequired,
    displayProp: Proptypes.func.isRequired,
    valueProp: Proptypes.string.isRequired,
    notify: Proptypes.func.isRequired
};

export default RemoteCheckboxGroup;



// WEBPACK FOOTER //
// ./components/data-containers/remoteCheckboxGroup.js